module.exports = __webpack_public_path__ + "img/past-events_super-bowl.d0311662.jpg";